/* eslint-disable react-hooks/rules-of-hooks */
import { OrderOperationType } from 'api/types/entity/account/order';
import { ErrorLayout } from 'components';
import { useGetNavigateSearchParams } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { usePageTitleTranslation } from 'libs/navigation';

import { OrderOperationTypeForQuery } from '../../types';
import { useCreateOrder, useDirectories } from '../hooks';
import { CreateOrderProvider } from '../providers/OrderProvider';
import { CreateOrderView } from '../views/CreateOrderView';

export const CreateOrderContainer = () => {
  const { type: queryOrderType } = useGetNavigateSearchParams(['type']);
  const { t } = useTranslation();

  let orderType: OrderOperationType | undefined;

  switch (queryOrderType) {
    case OrderOperationTypeForQuery.SecuritiesPurchase:
      orderType = OrderOperationType.SecuritiesPurchase;
      break;
    case OrderOperationTypeForQuery.SecuritiesSale:
      orderType = OrderOperationType.SecuritiesSale;
      break;
    case OrderOperationTypeForQuery.SecuritiesWithdrawal:
      orderType = OrderOperationType.SecuritiesWithdrawal;
      break;
    case OrderOperationTypeForQuery.SecuritiesDeposit:
      orderType = OrderOperationType.SecuritiesDeposit;
      break;
    default:
      return <ErrorLayout subtitle={t('notFound.subtitle')} />;
  }

  const {
    initialValues,
    disabledDates,
    submitLoading,
    loading,
    formError,
    orderSchema,
    minEndDate,
    brokerTimezoneOffset,
    onSubmit,
    validateOrder,
  } = useCreateOrder({ orderType: orderType! });

  const {
    loading: directoriesLoading,
    directories,
    schemas,
  } = useDirectories({
    orderSchema,
  });

  usePageTitleTranslation('account.createOrder.pageTitle');

  return (
    <CreateOrderProvider
      brokerTimezoneOffset={brokerTimezoneOffset}
      directories={directories}
      disabledDates={disabledDates}
      minEndDate={minEndDate}
      orderType={orderType}
      schemas={schemas}
    >
      <CreateOrderView
        formError={formError}
        initialValues={initialValues}
        loading={loading || directoriesLoading}
        submitLoading={submitLoading}
        validateOrder={validateOrder}
        onSubmit={onSubmit}
      />
    </CreateOrderProvider>
  );
};
